import type { StyleObject } from 'styletron-standard'

import palette from 'constants/palette'

// The fixed-list rows as the mockup draws them
export const ROW_GAP = '14px'
export const SUB_ROW_PADDING_Y = '12px'
const ROW_PADDING_X = '16px'

/** A UID group or store UID listed on its own */
export const UID_ROW_STYLE: StyleObject = {
  minHeight: '60px',
  padding: `14px ${ROW_PADDING_X}`,
  gap: ROW_GAP,
  alignItems: 'flex-start',
}

/**
 * A store UID under its global. It paints its own background across the
 * whole row, the tree guide included, so the indent is never a blank notch.
 */
export const subRowStyleOf = (selected: boolean): StyleObject => {
  const backgroundColor = selected ? palette.belizeHole10 : palette.grey05
  return {
    minHeight: '56px',
    padding: `${SUB_ROW_PADDING_Y} ${ROW_PADDING_X}`,
    gap: ROW_GAP,
    alignItems: 'flex-start',
    backgroundColor,
    ':hover': {
      backgroundColor: selected ? palette.belizeHole10 : palette.grey10,
    },
  }
}
